import { useMemo } from "react";
import type { ProtoAppearance } from "@catbento/shared";
import { readSnapshot } from "../data/snapshot.js";
import { getMatches } from "../data/matches.js";

// Phase 02 seam: a player's match appearances (the Matches Gantt rows). Empty
// array when the player is absent or has no captured appearances. At the Part-2
// cutover this hook fetches GET /player-appearances and adapts to the same
// ProtoAppearance[] shape.
export function useMatches(name: string): ProtoAppearance[] {
  return useMemo(() => getMatches(readSnapshot().players, name), [name]);
}
